import React, { useState } from 'react';
import { connect, useSelector } from "react-redux";
import {
    CardBody, Col, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";

import {FL_CATEGORY, FL_CODE, FL_STATUS, FL_TITLE} from "../../../components/i18n/formLabels";
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";

import { setFilter } from "../../../redux/actions/generics/IndexedActions";
import { getStateByPath } from "../../../redux/selectors";
import {PH_CODE, PH_TITLE} from "../../../components/i18n/placeHolders";
import SelectGeneric from "../../../components/select/selectGeneric";
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import {typePlaceProvider} from "../../../providers/typePlaceProvider";

const PlaceControllerFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter, app, udn } = componentState?.data;

    const [status, setStatus] = useState(filter?.item?.status !== undefined ? filter?.item?.status : null);
    const [categoryId, setCategoryId] = useState(filter?.item?.category?.id || null);
    const [typePlaceId, setTypePlaceId] = useState(filter?.item?.typePlace?.id || null);
    const [resetValue, setResetValue] = useState(false);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
        }
    });

    const onSubmit = (data, _) => {
        if(!app?.fbDataBase?.id)
            return

        const dataFilter = {
            fbDataBase : { id : app?.fbDataBase?.id },
            onlyRegistered : onlyRegistered,
            item : {
                ...data,
                udn	 : { id : udn.id },
                status
            }
        };

        if (categoryId !== undefined && categoryId !== null && categoryId !== '')
            dataFilter.item.category = { id : categoryId };

        if (typePlaceId !== undefined && typePlaceId !== null && typePlaceId !== '')
            dataFilter.item.typePlace = { id : typePlaceId };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        setCategoryId(null);
        setStatus(null);
        setResetValue( !resetValue )
        reset({
            code: ''
        });

        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.onlyRegistered;
            delete tmpFilter.item.status;
        }
        props.setFilter(path, tmpFilter);
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>{ FL_TITLE }</Label>
                            <Input type="text"
                                   name="title"
                                   placeholder={ PH_TITLE }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{ FL_CODE }</Label>
                            <Input type="text"
                                   name="code"
                                   placeholder={ PH_CODE }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ FL_STATUS }</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Solo en app</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{ FL_CATEGORY }</Label>
                            <SelectGeneric
                                initialValue={ categoryId }
                                setExternalValue={ value => setCategoryId( value ) }
                                isDisabled={ false }
                                provider = { hotelCategoryProvider }
                                getAllCategories={true}
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{ 'Tipo de lugar' }</Label>
                            <SelectGeneric
                                initialValue={ typePlaceId }
                                setExternalValue={ value => setTypePlaceId( value ) }
                                isDisabled={ false }
                                provider = { typePlaceProvider }
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter
})

export default connect(mapStateToProps, mapActionsToProps)(PlaceControllerFilters)
